import { z } from 'zod'

// Компания-заказчик. Реквизиты вложены (не плоские INN/kind); контакты — массив.
export const RequisitesSchema = z.object({
  legal_name: z.string().optional(),
  inn: z.string().optional(),
  kpp: z.string().optional(),
  ogrn: z.string().optional(),
  legal_address: z.string().optional(),
  bank_details: z.string().optional(),
})
export type Requisites = z.infer<typeof RequisitesSchema>

export const ContactSchema = z.object({
  name: z.string(),
  job_title: z.string().optional(),
  phone: z.string().optional(),
  email: z.string().optional(),
})
export type Contact = z.infer<typeof ContactSchema>

export const CompanyLinkSchema = z.object({ title: z.string(), url: z.string() })
export type CompanyLink = z.infer<typeof CompanyLinkSchema>

// Строка справочника компаний (employee-only): счётчики сделок + метки.
export const CompanyListItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string(),
  project_count: z.number(),
  // Суммарная сумма сделок компании (бэк отдаёт всегда в этом листинге).
  projects_total_kopecks: z.number(),
  tags: z.array(z.string()).optional(),
  // Компания убрана в архив: из справочника ушла, видна только с тумблером.
  archived: z.boolean().default(false),
})
export type CompanyListItem = z.infer<typeof CompanyListItemSchema>

// Сводка по выданным заказчику проектам его компании (customer-only срез).
export const CustomerProjectsSummarySchema = z.object({
  active: z.number(),
  won: z.number(),
  lost: z.number(),
})
export type CustomerProjectsSummary = z.infer<typeof CustomerProjectsSummarySchema>

// project_count/projects_total_kopecks/tags — employee-only статистика и метки,
// у заказчика (читает свою компанию) отсутствуют; customer_projects — наоборот.
export const CompanySchema = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string(),
  requisites: RequisitesSchema,
  contacts: z.array(ContactSchema),
  // Полезные ссылки компании (сайт, папки, доски). Бэк опускает пустой набор —
  // коалесим в [].
  links: z.array(CompanyLinkSchema).default([]),
  // Компания убрана в архив: карточка открывается, но из работы она выведена.
  archived: z.boolean().default(false),
  version: z.number(),
  created_at: z.string(),
  updated_at: z.string(),
  project_count: z.number().optional(),
  projects_total_kopecks: z.number().optional(),
  tags: z.array(z.string()).optional(),
  customer_projects: CustomerProjectsSummarySchema.optional(),
})
export type Company = z.infer<typeof CompanySchema>
